module.exports = __webpack_public_path__ + "img/DE00272.f9724e79.svg";